var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7634_175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7634_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8501 15.3002C5.47885 15.3002 5.16103 15.168 4.89666 14.9036C4.63228 14.6393 4.5001 14.3214 4.5001 13.9502V4.9502H3.6001V3.6002H7.2001V2.7002H10.8001V3.6002H14.4001V4.9502H13.5001V13.9421C13.5001 14.3225 13.3679 14.6439 13.1035 14.9064C12.8392 15.1689 12.5213 15.3002 12.1501 15.3002H5.8501ZM12.1501 4.9502H5.8501V13.9502H12.1501V4.9502ZM7.2001 12.6002H8.5501V6.3002H7.2001V12.6002ZM9.4501 12.6002H10.8001V6.3002H9.4501V12.6002Z",
    fill: "#3E444D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d61c4bd8.svg";
export { ForwardRef as ReactComponent };